import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import * as unsubscribeService from '../../services/unsubscribeService';
import globalActionConstants from '../constants/globalActionConstants';
import unsubscribeActionConstants from '../constants/unsubscribeActionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export const unsubscribeReferralRoundup = (token) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  dispatch({ type: unsubscribeActionConstants.UNSUBSCRIBE_REFERRAL_ROUNDUP });

  try {
    const response = await unsubscribeService.unsubscribeReferralRoundup(token);
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });

    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: unsubscribeActionConstants.UNSUBSCRIBE_REFERRAL_ROUNDUP_SUCCESS });
    } else {
      dispatch({ type: unsubscribeActionConstants.UNSUBSCRIBE_REFERRAL_ROUNDUP_ERROR });
      Notification.error(response.data.error || t('notifications.failedToUnsubscribe'));
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    dispatch({ type: unsubscribeActionConstants.UNSUBSCRIBE_REFERRAL_ROUNDUP_ERROR });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};
